<template>
  <div class="guest">
    <div class="guestTop">
        <div class="guestTopTitle">{{ props.data.titleCn }}</div>
        <div class="guestTopEn">{{ props.data.titleEn }}</div>
    </div>
    <van-swipe :autoplay="3000" class="swipe">
      <van-swipe-item v-for="(item, index) in arr" :key="index">
        <div class="guestBox">
          <div v-for="(node, index) in item" :key="index" class="guestBoxItem">
            <img :src="node.avatar" alt="" class="guestBoxItemAvatar" />
            <div class="guestBoxItemName">{{ node.name }}</div>
            <div class="guestBoxItemTitle guestBoxItemText van-multi-ellipsis--l3">{{ node.title.join(',') }}</div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { getKeyGuest } from '@/api/2024/index'

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})

const arr = ref([])

onBeforeMount(async () => {
  await fetch()
})

const fetch = () => {
  getKeyGuest('ISC 荣誉主席,重磅嘉宾',2).then((res) => {
    let guests = res.data.data
    arr.value = chunkArray(guests, 3)
  })
}

const chunkArray = (array, chunkSize) => {
  const result = []
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize))
  }
  return result
}
</script>

<style lang="scss" scoped>
.guest {
  opacity: 1;
  padding: 72px 20px 0px;
  &Top {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 32px;
    &Title {
      color: rgb(44, 44, 44);
      font-family: Source Han Sans;
      font-size: 32px;
      font-weight: 700;
      line-height: 32px;
      letter-spacing: 0px;
      text-transform: uppercase;
    }
    &En {
      color: rgb(44, 44, 44);
      font-family: Rubik;
      font-size: 14px;
      font-weight: 400;
      line-height: 14px;
      letter-spacing: 0px;
      text-transform: uppercase;
      margin-top: 12px;
    }
  }
  &Box {
    display: flex;
    justify-content: space-between;
    &Item {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      &Avatar {
        width: 96px;
        height: 96px;
        border-radius: 50%;
      }
      &Name {
        font-family: Source Han Sans;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        letter-spacing: 0px;
        font-variation-settings: 'opsz' auto;
        /* Gray 中性/gray-9 */
        color: #242933;
        margin: 8px 0;
        text-align: center;
      }
      &Text {
        width: 96px;
        font-family: Source Han Sans;
        font-size: 12px;
        font-weight: normal;
        line-height: 20px;
        text-align: center;
        letter-spacing: 0px;
        font-variation-settings: 'opsz' auto;
        color: rgba(61, 61, 61, 0.698);
        text-align: center;
      }
    }
  }
  :deep(.van-swipe__indicators) {
    position: relative;
    margin-top: 35px;
    justify-content: center;
  }
  .swipe {
    --van-swipe-indicator-active-background: #525966;
    --van-swipe-indicator-inactive-background: #dfe1e6;
    --van-swipe-indicator-size: 8px;
  }
}
</style>
